import React, { useEffect, useRef } from 'react';
import './IframeVideoPlayer.scss';

const IframeVideoPlayer = ({ src }) => {
  const sourceDomain =
      window.location.hostname.split('.')[0] === 'local-sports'
          ? window.location.hostname + ':3000'
          : window.location.hostname;
  const poster = 'https://bigwin.livenst.com/static/upload/3f9a894f-4b7f-4fd9-915a-32c8ff4319cb.jpg';

  return (
      <div className='iframe_box'>
          <iframe
              id='iframe_tv_1'
              name='iframe_tv_1'
              className='tv_iframe'
              src={`https://liventv.com/player?${src}&targetId=513&sourceDomain=${sourceDomain}&poster=${encodeURIComponent(
                  poster
              )}`}
              width='100%'
              allow='autoplay'
              allowFullScreen='true'
              webkitallowfullscreen='true'
              mozallowfullscreen='true'
              frameBorder='0'
              scrolling='no'
              referrerPolicy='unsafe-url'
          />
          <div className='video_guide'>
              전체화면으로 전환 후 스마트폰을 가로로 돌리면 더 큰 화면으로 시청하실 수 있습니다.
          </div>
      </div>
  );
};

export {IframeVideoPlayer};
